import { Injectable, inject } from '@angular/core';

import { StorageService } from '../storage';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly storageService = inject(StorageService);

  isAuthenticated(): boolean {
    return !!this.storageService.getToken();
  }

  saveToken(token: string): void {
    this.storageService.setToken(token);
  }

  logout(): void {
    this.storageService.clear();
  }
}
